import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ProjectStatistics } from "./ui";

export function ProjectStatisticsRoute(...rest: RouteObject[]): RouteObject {
  return {
    path: routes.project.statistics(),
    element: createElement(ProjectStatistics),
    children: rest,
  };
}
